<script lang="ts">
  import Modal from '@/components/shared/modals/Modal.svelte'

  let {
    keyword = {}
  } = $props()

  function onShow() {
    window.setTimeout(App.syntax_highlighting.init, 25)
  }

</script>

<Modal id="auto-responder-widget" {onShow}>
  {#snippet trigger(toggle)}
    <div class="AutoResponderWidget panel shaded">
      <p>
        Want to add an Auto-response form on your own site?
      </p>
      <p class="text-center">
        <button class="btn btn-default" onclick={toggle}>Show me the Code</button>
      </p>
    </div>
  {/snippet}

  {#snippet title()}
    Auto Responder Widget
  {/snippet}

  {#snippet content()}
    <p>
      This will place a simple form to collect a US mobile phone number anywhere you want on your own web site. Upon
      submitting, it will send this Group's auto-response to the phone entered.
    </p>
    <br>
    <p>
      Copy and paste this into your web page:
    </p>
    <pre><code>
  &lt;script src="{location.protocol}//{location.host}/widgets/auto_responders/{keyword.api_id}">&lt;/script>

  &lt;script>
  var config = &lbrace; el: '#my-element' }
  new TSAutoResponder(config)
  &lt;/script>
      </code></pre>
    <br>
    <p>
      If you wish, you can customize its appearance through the following config variables:
    </p>
    <pre><code>config:
  el:
    (required) CSS selector of the element at which to mount the widget

  placeholderText:
    (optional) Placeholder text for the phone number field

  buttonText:
    (optional) Text for the submit button

  inputClass:
    (optional) CSS class for the phone number field

  buttonClass:
    (optional) CSS class for the submit button

  errorsClass:
    (optional) CSS class for the errors element</code></pre>
  {/snippet}
</Modal>
